/* ═══════════════════════════════════════════════════════════
   AMEZONI CRYSTALS — Shopify Theme JavaScript
   ═══════════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function() {

  /* ─── Navbar Scroll Effect ─── */
  const navbar = document.querySelector('.navbar');
  const navLinks = document.querySelectorAll('.navbar-link');

  var announcementBar = document.getElementById('announcement-bar');

  function handleScroll() {
    if (!navbar) return;
    if (window.scrollY > 20) {
      navbar.classList.add('scrolled');
    } else {
      navbar.classList.remove('scrolled');
    }

    /* Adjust navbar top to follow announcement bar on scroll.
       Clamp scrollY to >= 0 so rubber-band overscroll (iOS/macOS trackpad)
       doesn't push the navbar downward when the user pulls past the top. */
    if (announcementBar && document.body.classList.contains('has-announcement')) {
      var barH = announcementBar.offsetHeight;
      var clampedScroll = Math.max(0, window.scrollY);
      navbar.style.top = Math.max(0, barH - clampedScroll) + 'px';
    }

    // Active section detection
    const sections = document.querySelectorAll('section[id]');
    let current = '';
    sections.forEach(function(section) {
      const top = section.getBoundingClientRect().top;
      if (top <= 120) { current = section.getAttribute('id'); }
    });
    navLinks.forEach(function(link) {
      link.classList.remove('active');
      if (link.getAttribute('href') === '/#' + current || link.getAttribute('href') === '#' + current) {
        link.classList.add('active');
      }
    });
  }
  var scrollTicking = false;
  window.addEventListener('scroll', function() {
    if (!scrollTicking) {
      requestAnimationFrame(function() {
        handleScroll();
        scrollTicking = false;
      });
      scrollTicking = true;
    }
  }, { passive: true });
  handleScroll();

  /* ─── Smooth Scroll for Anchor Links ─── */
  document.querySelectorAll('a[href^="#"], a[href^="/#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var targetId = this.getAttribute('href');
      if (targetId === '#') return;
      // Strip leading "/" for /#section links
      if (targetId.startsWith('/')) targetId = targetId.substring(1);
      var target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (typeof window.amezoniSetMobileMenuOpen === 'function') {
          window.amezoniSetMobileMenuOpen(false);
        }
      }
    });
  });

  /* ─── Mobile Menu Toggle ─── */
  var menuToggle = document.getElementById('menu-toggle');
  var mobileMenu = document.querySelector('.mobile-menu');
  var menuIcon = document.getElementById('menu-icon');
  var closeIcon = document.getElementById('close-icon');
  var lastMobileMenuFocus = null;

  function getMobileMenuFocusables() {
    if (!mobileMenu) return [];
    return Array.prototype.slice.call(mobileMenu.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function(el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  function setMobileMenuOpen(open, options) {
    if (!menuToggle || !mobileMenu) return;

    if (open && typeof window.amezoniCloseNavbarSearch === 'function') {
      window.amezoniCloseNavbarSearch();
    }

    var isOpen = !!open;
    mobileMenu.classList.toggle('open', isOpen);
    mobileMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    menuToggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    document.body.classList.toggle('mobile-menu-open', isOpen);
    if (menuIcon) menuIcon.style.display = isOpen ? 'none' : 'block';
    if (closeIcon) closeIcon.style.display = isOpen ? 'block' : 'none';

    if (isOpen) {
      lastMobileMenuFocus = document.activeElement;
      if (typeof mobileMenu.focus === 'function') {
        try { mobileMenu.focus({ preventScroll: true }); } catch (e) { mobileMenu.focus(); }
      }
    } else {
      var shouldRestoreFocus = !options || options.restoreFocus !== false;
      if (shouldRestoreFocus && lastMobileMenuFocus && typeof lastMobileMenuFocus.focus === 'function') {
        try { lastMobileMenuFocus.focus({ preventScroll: true }); } catch (e) { lastMobileMenuFocus.focus(); }
      }
      lastMobileMenuFocus = null;
    }
  }

  function trapMobileMenuFocus(event) {
    if (!mobileMenu || !mobileMenu.classList.contains('open') || event.key !== 'Tab') return;
    var focusables = getMobileMenuFocusables();
    if (!focusables.length) {
      event.preventDefault();
      return;
    }
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  window.amezoniSetMobileMenuOpen = setMobileMenuOpen;

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function() {
      setMobileMenuOpen(!mobileMenu.classList.contains('open'));
    });
    mobileMenu.addEventListener('keydown', trapMobileMenuFocus);
    mobileMenu.addEventListener('click', function(event) {
      if (event.target.closest('a[href]')) setMobileMenuOpen(false, { restoreFocus: false });
    });
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && mobileMenu.classList.contains('open')) {
        setMobileMenuOpen(false);
      }
    });
    document.addEventListener('click', function(event) {
      if (!mobileMenu.classList.contains('open')) return;
      if (mobileMenu.contains(event.target) || menuToggle.contains(event.target)) return;
      setMobileMenuOpen(false);
    });
  }

  /* ─── Reveal on Scroll (Intersection Observer) ─── */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '-50px' });
    reveals.forEach(function(el) { observer.observe(el); });
  } else {
    reveals.forEach(function(el) { el.classList.add('visible'); });
  }

  /* ─── Count Up Animation ─── */
  var counters = document.querySelectorAll('[data-count]');
  if ('IntersectionObserver' in window) {
    var counterObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var end = parseInt(el.getAttribute('data-count'), 10);
          var suffix = el.getAttribute('data-suffix') || '';
          var duration = 2000;
          var start = 0;
          var step = end / (duration / 16);
          var timer = setInterval(function() {
            start += step;
            if (start >= end) {
              el.textContent = end.toLocaleString() + suffix;
              clearInterval(timer);
            } else {
              el.textContent = Math.floor(start).toLocaleString() + suffix;
            }
          }, 16);
          counterObserver.unobserve(el);
        }
      });
    }, { threshold: 0.5 });
    counters.forEach(function(el) { counterObserver.observe(el); });
  }

  /* ─── FAQ TOC pill-bar active state on scroll ─── */
  (function initFaqToc() {
    var pills = document.querySelectorAll('.faq-toc-pill');
    if (pills.length === 0 || !('IntersectionObserver' in window)) return;
    var headings = document.querySelectorAll('.faq-cat-heading[id]');
    if (headings.length === 0) return;
    var pillsByCat = {};
    pills.forEach(function(p) { pillsByCat[p.getAttribute('data-faq-cat')] = p; });
    var setActive = function(slug) {
      pills.forEach(function(p) { p.removeAttribute('data-active'); });
      var match = pillsByCat[slug];
      if (match) match.setAttribute('data-active', 'true');
    };
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var id = entry.target.getAttribute('id');
          if (id && id.indexOf('faq-cat-') === 0) {
            setActive(id.replace('faq-cat-', ''));
          }
        }
      });
    }, { rootMargin: '-150px 0px -60% 0px', threshold: 0 });
    headings.forEach(function(h) { observer.observe(h); });
  })();

  /* ─── FAQ Feedback (Was this helpful?) ─── */
  (function initFaqFeedback() {
    var widgets = document.querySelectorAll('.faq-feedback');
    if (widgets.length === 0) return;
    var STORAGE_KEY = 'faq-feedback';
    var stored;
    try { stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); }
    catch (e) { stored = {}; }

    widgets.forEach(function(widget) {
      var id = widget.getAttribute('data-faq-id');
      var buttons = widget.querySelectorAll('.faq-feedback-btn');
      var thanks = widget.querySelector('.faq-feedback-thanks');

      // Restore prior vote for this entry (same browser)
      if (stored[id]) {
        buttons.forEach(function(b) {
          b.disabled = true;
          if (b.getAttribute('data-vote') === stored[id]) {
            b.setAttribute('data-voted', 'true');
          }
        });
        if (thanks) thanks.hidden = false;
      }

      buttons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          if (btn.disabled) return;
          var vote = this.getAttribute('data-vote');
          buttons.forEach(function(b) {
            b.disabled = true;
            if (b === btn) b.setAttribute('data-voted', 'true');
          });
          if (thanks) thanks.hidden = false;

          // Persist (same browser only — no server)
          stored[id] = vote;
          try { localStorage.setItem(STORAGE_KEY, JSON.stringify(stored)); } catch (e) {}

          // Analytics: GA4 dataLayer (no-op if dataLayer not present)
          if (typeof window.dataLayer !== 'undefined') {
            var item = widget.closest('.faq-item');
            var qBtn = item ? item.querySelector('.faq-question') : null;
            var question = qBtn ? qBtn.textContent.trim().split('\n')[0].trim() : '';
            window.dataLayer.push({
              event: 'faq_feedback',
              faq_id: id,
              faq_question: question,
              vote: vote
            });
          }
        });
      });
    });
  })();

  /* ─── FAQ Accordion ─── */
  document.querySelectorAll('.faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.faq-item');
      var parent = item.parentElement;
      parent.querySelectorAll('.faq-item.open').forEach(function(openItem) {
        if (openItem !== item) {
          openItem.classList.remove('open');
          var ob = openItem.querySelector('.faq-question');
          var oa = openItem.querySelector('.faq-answer');
          if (ob) ob.setAttribute('aria-expanded', 'false');
          if (oa) {
            oa.setAttribute('aria-hidden', 'true');
            oa.setAttribute('inert', '');
          }
        }
      });
      var isOpen = item.classList.toggle('open');
      this.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      var ans = item.querySelector('.faq-answer');
      if (ans) {
        if (isOpen) {
          ans.setAttribute('aria-hidden', 'false');
          ans.removeAttribute('inert');
        } else {
          ans.setAttribute('aria-hidden', 'true');
          ans.setAttribute('inert', '');
        }
      }
    });
  });

  /* ─── Collection Filter Tabs (Animated) — scoped per section ─── */
  document.querySelectorAll('.collections-showcase-section').forEach(function(section) {
    var filterTabs = section.querySelectorAll('.filter-tab');
    var productCards = section.querySelectorAll('.product-card[data-type]');
    var productGrid = section.querySelector('.products-grid');

    filterTabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var type = this.getAttribute('data-filter');

        // Update active tab (scoped to this section)
        filterTabs.forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');

        // Auto-scroll tab into view (horizontal only, no page jump)
        var tabsContainer = this.parentElement;
        if (tabsContainer) {
          var tabLeft = this.offsetLeft;
          var tabWidth = this.offsetWidth;
          var containerWidth = tabsContainer.offsetWidth;
          tabsContainer.scrollTo({ left: tabLeft - (containerWidth / 2) + (tabWidth / 2), behavior: 'smooth' });
        }

        // Lock grid height to prevent layout jump
        if (productGrid) {
          productGrid.style.minHeight = productGrid.offsetHeight + 'px';
        }

        // Phase 1: fade out cards that will be hidden
        productCards.forEach(function(card) {
          card.classList.remove('filter-showing');
          var shouldShow = card.getAttribute('data-type') === type;
          if (!shouldShow) {
            card.classList.add('filter-hiding');
          }
        });

        // Phase 2: after fade-out, toggle display and fade in
        setTimeout(function() {
          var visibleCount = 0;
          productCards.forEach(function(card) {
            var shouldShow = card.getAttribute('data-type') === type;
            if (shouldShow) {
              card.style.display = '';
              card.classList.remove('filter-hiding');
              visibleCount++;
            } else {
              card.style.display = 'none';
              card.classList.remove('filter-hiding');
            }
          });

          // Staggered fade-in
          var delay = 0;
          productCards.forEach(function(card) {
            if (card.style.display !== 'none') {
              card.style.animationDelay = delay + 'ms';
              card.classList.add('filter-showing');
              delay += 50;
            }
          });

          // Release grid height after all animations
          setTimeout(function() {
            if (productGrid) productGrid.style.minHeight = '';
            productCards.forEach(function(card) {
              card.classList.remove('filter-showing');
              card.style.animationDelay = '';
            });
          }, delay + 500);
        }, 300);
      });
    });

    /* ─── Filter Tabs Scroll Indicators (scoped) ─── */
    var filterTabsWrapper = section.querySelector('.filter-tabs-wrapper');
    var filterTabsScroll = section.querySelector('.filter-tabs');

    function updateScrollIndicators() {
      if (!filterTabsWrapper || !filterTabsScroll) return;
      var sl = filterTabsScroll.scrollLeft;
      var sw = filterTabsScroll.scrollWidth;
      var cw = filterTabsScroll.clientWidth;
      filterTabsWrapper.classList.toggle('can-scroll-left', sl > 5);
      filterTabsWrapper.classList.toggle('can-scroll-right', sl < sw - cw - 5);
    }

    if (filterTabsScroll) {
      filterTabsScroll.addEventListener('scroll', updateScrollIndicators);
      window.addEventListener('resize', updateScrollIndicators);
      setTimeout(updateScrollIndicators, 100);
    }

    /* ─── Category Cards Carousel Dots (scoped) ─── */
    var catTrack = section.querySelector('.cat-cards-track');
    var catDots = section.querySelectorAll('.cat-cards-dot');

    if (catTrack && catDots.length > 0) {
      catTrack.addEventListener('scroll', function() {
        var scrollLeft = catTrack.scrollLeft;
        var card = catTrack.querySelector('.cat-card');
        if (!card) return;
        var cardWidth = card.offsetWidth;
        var gap = parseFloat(getComputedStyle(catTrack).gap) || 12;
        var index = Math.round(scrollLeft / (cardWidth + gap));
        catDots.forEach(function(dot, i) {
          dot.classList.toggle('active', i === index);
        });
      });

      catDots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var index = parseInt(this.getAttribute('data-index'), 10);
          var cards = catTrack.querySelectorAll('.cat-card');
          if (cards[index]) {
            cards[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          }
        });
      });
    }

  });

  /* ─── Form Submissions (Shopify-compatible) ─── */
  var wholesaleForm = document.getElementById('wholesale-form');
  if (wholesaleForm) {
    wholesaleForm.addEventListener('submit', function(e) {
      var btn = this.querySelector('button[type="submit"]');
      if (btn) {
        btn.textContent = 'Submitting...';
        btn.disabled = true;
      }
    });
  }

  var contactForm = document.getElementById('contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', function(e) {
      var btn = this.querySelector('button[type="submit"]');
      if (btn) {
        btn.textContent = 'Sending...';
        btn.disabled = true;
      }
    });
  }

  var newsletterForm = document.getElementById('newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function() {
      var btn = this.querySelector('button[type="submit"]');
      if (btn) {
        btn.textContent = 'Subscribing...';
        btn.disabled = true;
      }
    });
  }

  /* ─── Product Detail Page (PDP) ─── */
  var pdpGallery = document.getElementById('pdp-gallery');
  var pdpProductData = window.amezoniProduct || null;

  if (pdpGallery && pdpProductData) {
    var pdpMainImg = document.getElementById('pdp-main-img');
    var pdpMainVideo = document.getElementById('pdp-main-video');
    var pdpZoomBtn = document.getElementById('pdp-zoom-btn');
    var pdpThumbs = document.getElementById('pdp-thumbs');
    var pdpCurrentIndex = 0;
    var pdpMediaCount = pdpProductData.mediaCount || 0;
    var pdpIsVideo = false; /* tracks if current media is video */

    function pdpPauseVideos() {
      if (!pdpMainVideo) return;
      var vms = pdpMainVideo.querySelectorAll('video-media');
      vms.forEach(function(vm) { if (vm.pause) vm.pause(); });
      /* Fallback for plain video/iframe without video-media */
      var videos = pdpMainVideo.querySelectorAll('video:not(video-media video)');
      videos.forEach(function(v) { v.pause(); });
      var iframes = pdpMainVideo.querySelectorAll('iframe:not(video-media iframe)');
      iframes.forEach(function(f) {
        try { f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'); } catch(e) {}
      });
    }

    function pdpShowImage(src, zoom, alt) {
      pdpPauseVideos();
      pdpIsVideo = false;
      if (pdpMainVideo) { pdpMainVideo.classList.remove('active'); pdpMainVideo.style.display = 'none'; pdpMainVideo.innerHTML = ''; }
      var wrap = document.getElementById('pdp-main-wrap');
      if (wrap) wrap.classList.remove('is-video');
      if (pdpMainImg && src) {
        pdpMainImg.style.display = '';
        pdpMainImg.removeAttribute('srcset');
        if (wrap) wrap.classList.add('pdp-loading');
        pdpMainImg.src = src;
        pdpMainImg.setAttribute('data-zoom', zoom || src);
        if (alt) pdpMainImg.alt = alt;
        pdpMainImg.onload = function() { if (wrap) wrap.classList.remove('pdp-loading'); };
      }
      if (pdpZoomBtn) pdpZoomBtn.style.display = '';
    }

    function pdpShowVideo(videoHtml) {
      pdpPauseVideos();
      pdpIsVideo = true;
      var wrap = document.getElementById('pdp-main-wrap');
      if (wrap) wrap.classList.add('is-video');
      if (pdpMainImg) pdpMainImg.style.display = 'none';
      if (pdpMainVideo) {
        pdpMainVideo.innerHTML = videoHtml;
        pdpMainVideo.classList.add('active');
        pdpMainVideo.style.display = '';
        /* Let video-media handle playback if present */
        var vm = pdpMainVideo.querySelector('video-media');
        if (vm) {
          if (vm.play) vm.play();
        } else {
          var vid = pdpMainVideo.querySelector('video');
          if (vid) {
            vid.muted = true;
            vid.setAttribute('controlslist', 'nodownload noplaybackrate');
            vid.setAttribute('disablepictureinpicture', '');
            vid.play().catch(function() {});
          }
        }
      }
      if (pdpZoomBtn) pdpZoomBtn.style.display = 'none';
    }

    function pdpSetActiveThumb(index) {
      if (!pdpThumbs) return;
      var all = pdpThumbs.querySelectorAll('.pdp-thumb');
      all.forEach(function(t, i) { t.classList.toggle('active', i === index); });
    }

    function pdpNavigateToIndex(index) {
      var thumb = pdpThumbs ? pdpThumbs.querySelector('[data-index="' + index + '"]') : null;
      if (!thumb) return;
      var mediaType = thumb.getAttribute('data-media-type');
      if (mediaType === 'video' || mediaType === 'external_video') {
        pdpShowVideo(thumb.getAttribute('data-video-html'));
      } else {
        pdpShowImage(thumb.getAttribute('data-full'), thumb.getAttribute('data-zoom'), thumb.getAttribute('data-alt'));
      }
      pdpSetActiveThumb(index);
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    /* ── Thumbnail click ── */
    if (pdpThumbs) {
      pdpThumbs.addEventListener('click', function(e) {
        var thumb = e.target.closest('.pdp-thumb');
        if (!thumb) return;
        pdpCurrentIndex = parseInt(thumb.getAttribute('data-index'), 10);
        pdpNavigateToIndex(pdpCurrentIndex);
      });
    }

    /* ── Prev / Next nav buttons ── */
    var prevBtn = document.getElementById('pdp-nav-prev');
    var nextBtn = document.getElementById('pdp-nav-next');
    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        pdpCurrentIndex = (pdpCurrentIndex - 1 + pdpMediaCount) % pdpMediaCount;
        pdpNavigateToIndex(pdpCurrentIndex);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        pdpCurrentIndex = (pdpCurrentIndex + 1) % pdpMediaCount;
        pdpNavigateToIndex(pdpCurrentIndex);
      });
    }

    /* ── Swipe gesture (main viewer only — lightbox has its own handlers) ── */
    var pdpMainWrap = document.getElementById('pdp-main-wrap');
    if (pdpMainWrap && pdpMediaCount > 1) {
      var swipeStartX = 0;
      var swipeStartY = 0;
      var swipeActive = false;
      var SWIPE_THRESHOLD = 50;       /* px of horizontal travel to trigger nav */
      var SWIPE_AXIS_DOMINANCE = 1.5; /* |dx| must exceed |dy| by this factor (avoid stealing vertical scroll) */

      pdpMainWrap.addEventListener('pointerdown', function(e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return; /* left-click only for mouse */
        swipeStartX = e.clientX;
        swipeStartY = e.clientY;
        swipeActive = true;
      });
      pdpMainWrap.addEventListener('pointerup', function(e) {
        if (!swipeActive) return;
        swipeActive = false;
        var dx = e.clientX - swipeStartX;
        var dy = e.clientY - swipeStartY;
        if (Math.abs(dx) < SWIPE_THRESHOLD) return;
        if (Math.abs(dx) < Math.abs(dy) * SWIPE_AXIS_DOMINANCE) return;
        if (dx < 0) {
          pdpCurrentIndex = (pdpCurrentIndex + 1) % pdpMediaCount;
        } else {
          pdpCurrentIndex = (pdpCurrentIndex - 1 + pdpMediaCount) % pdpMediaCount;
        }
        pdpNavigateToIndex(pdpCurrentIndex);
      });
      pdpMainWrap.addEventListener('pointercancel', function() { swipeActive = false; });
    }

    /* ── Lightbox zoom (images only) ── */
    var lightbox = document.getElementById('pdp-lightbox');
    var lightboxImg = document.getElementById('pdp-lightbox-img');
    var lightboxClose = document.getElementById('pdp-lightbox-close');
    var lightboxPrevFocus = null;

    function openLightbox() {
      if (!lightbox || !pdpMainImg || pdpIsVideo) return;
      lightboxPrevFocus = document.activeElement;
      lightboxImg.src = pdpMainImg.getAttribute('data-zoom') || pdpMainImg.src;
      lightboxImg.alt = pdpMainImg.alt;
      lightbox.classList.add('open');
      lightbox.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      if (lightboxClose) {
        try { lightboxClose.focus({ preventScroll: true }); } catch (_) { lightboxClose.focus(); }
      }
    }
    function closeLightbox() {
      if (!lightbox || !lightbox.classList.contains('open')) return;
      lightbox.classList.remove('open');
      lightbox.classList.remove('pdp-lightbox-dragging');
      lightbox.setAttribute('aria-hidden', 'true');
      if (lightboxImg) {
        lightboxImg.style.transform = '';
        lightboxImg.style.opacity = '';
      }
      document.body.style.overflow = '';
      if (lightboxPrevFocus && typeof lightboxPrevFocus.focus === 'function') {
        try { lightboxPrevFocus.focus({ preventScroll: true }); } catch (_) { lightboxPrevFocus.focus(); }
      }
      lightboxPrevFocus = null;
    }
    function trapLightboxTab(e) {
      if (!lightbox || !lightbox.classList.contains('open')) return;
      if (e.key !== 'Tab') return;
      var focusables = lightbox.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) { e.preventDefault(); return; }
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    if (pdpZoomBtn) pdpZoomBtn.addEventListener('click', openLightbox);
    if (pdpMainImg) pdpMainImg.addEventListener('click', openLightbox);
    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    if (lightbox) lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeLightbox();
    });
    if (lightbox) lightbox.addEventListener('keydown', trapLightboxTab);

    /* ── Lightbox: swipe-down-to-close (iOS-native gesture pattern) ── */
    if (lightbox && lightboxImg) {
      var dragStartY = 0;
      var dragStartX = 0;
      var dragCurrentY = 0;
      var isDragging = false;
      var DISMISS_THRESHOLD = 100; /* px of vertical drag to close */
      var H_LOCK_THRESHOLD = 12;   /* px of horizontal drag before treating as scroll/zoom (cancel) */

      function onTouchStart(e) {
        if (!lightbox.classList.contains('open')) return;
        if (e.touches.length !== 1) { isDragging = false; return; }
        var t = e.touches[0];
        dragStartY = t.clientY;
        dragStartX = t.clientX;
        dragCurrentY = 0;
        isDragging = true;
        lightboxImg.style.transition = 'none';
      }
      function onTouchMove(e) {
        if (!isDragging) return;
        var t = e.touches[0];
        var dy = t.clientY - dragStartY;
        var dx = t.clientX - dragStartX;
        /* Cancel drag if horizontal motion dominates (user is scrolling/zooming, not dismissing) */
        if (Math.abs(dx) > H_LOCK_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
          isDragging = false;
          lightboxImg.style.transition = 'transform 0.2s ease, opacity 0.2s ease';
          lightboxImg.style.transform = '';
          lightboxImg.style.opacity = '';
          lightbox.classList.remove('pdp-lightbox-dragging');
          return;
        }
        /* Only respond to downward drag */
        if (dy < 0) dy = dy * 0.25; /* small rubberband on upward drag */
        dragCurrentY = dy;
        var progress = Math.min(Math.abs(dy) / 300, 1);
        var opacity = 1 - progress * 0.65;
        lightboxImg.style.transform = 'translateY(' + dy + 'px) scale(' + (1 - progress * 0.08) + ')';
        lightboxImg.style.opacity = opacity;
        lightbox.classList.add('pdp-lightbox-dragging');
        if (e.cancelable) e.preventDefault();
      }
      function onTouchEnd() {
        if (!isDragging) return;
        isDragging = false;
        lightboxImg.style.transition = 'transform 0.25s ease, opacity 0.25s ease';
        if (Math.abs(dragCurrentY) > DISMISS_THRESHOLD) {
          /* Animate out then close */
          var direction = dragCurrentY > 0 ? 1 : -1;
          lightboxImg.style.transform = 'translateY(' + (direction * window.innerHeight) + 'px) scale(0.9)';
          lightboxImg.style.opacity = '0';
          setTimeout(closeLightbox, 200);
        } else {
          /* Snap back */
          lightboxImg.style.transform = '';
          lightboxImg.style.opacity = '';
          lightbox.classList.remove('pdp-lightbox-dragging');
        }
        dragCurrentY = 0;
      }

      lightboxImg.addEventListener('touchstart', onTouchStart, { passive: true });
      lightboxImg.addEventListener('touchmove', onTouchMove, { passive: false });
      lightboxImg.addEventListener('touchend', onTouchEnd);
      lightboxImg.addEventListener('touchcancel', onTouchEnd);
    }

    /* ── Back button: use browser history if available ── */
    var backBtn = document.getElementById('pdp-back-btn');
    if (backBtn && document.referrer && document.referrer.indexOf(window.location.host) > -1) {
      backBtn.addEventListener('click', function(e) {
        e.preventDefault();
        history.back();
      });
    }

  }

  /* ─── PDP: Variant Selector + Quantity + Price ─── */
  var pdpPriceEl = document.getElementById('pdp-price');
  var pdpCompareEl = document.getElementById('pdp-compare-price');
  var pdpTotalEl = document.getElementById('pdp-total-value');
  var pdpTotalRow = document.getElementById('pdp-total-row');
  var pdpQtyInput = document.getElementById('pdp-qty-input');
  var pdpQtyMinus = document.getElementById('pdp-qty-minus');
  var pdpQtyPlus = document.getElementById('pdp-qty-plus');
  var pdpAddBtn = document.getElementById('pdp-add-btn');
  var pdpAddText = document.getElementById('pdp-add-text');
  var pdpStockWarning = document.getElementById('pdp-stock-warning');
  var pdpStockWarningText = document.getElementById('pdp-stock-warning-text');
  var pdpCurrentVariantPrice = pdpProductData ? pdpProductData.currentVariant.price : 0;
  var pdpCurrentVariantId = pdpProductData ? String(pdpProductData.currentVariant.id) : '';
  var pdpInventoryLimits = (pdpProductData && pdpProductData.inventoryLimits) || {};

  function pdpFormatMoney(cents) {
    var fmt = (pdpProductData && pdpProductData.moneyFormat) || '${{amount}}';
    fmt = fmt.replace(/<[^>]*>/g, '');
    var amount = (cents / 100).toFixed(2);
    return fmt
      .replace('{{amount}}', amount)
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100).toString());
  }

  function pdpGetMaxQty() {
    var info = pdpInventoryLimits[pdpCurrentVariantId];
    if (!info || info.max == null) return Infinity;
    return Math.max(0, parseInt(info.max, 10) || 0);
  }

  function pdpUpdateFreeShippingBadge(totalCents) {
    var badge = document.getElementById('pdp-free-shipping-badge');
    if (!badge) return;

    var threshold = (window.amezoniProduct && window.amezoniProduct.freeShippingThreshold) || 0;
    if (threshold <= 0) return;

    if (totalCents >= threshold) {
      badge.classList.add('visible');
    } else {
      badge.classList.remove('visible');
    }
  }

  function pdpUpdateTotal() {
    var qty = pdpQtyInput ? (parseInt(pdpQtyInput.value, 10) || 1) : 1;

    /* Show/hide total row */
    if (pdpTotalRow) {
      pdpTotalRow.style.display = qty > 1 ? '' : 'none';
    }
    if (pdpTotalEl && qty > 1) {
      var total = pdpCurrentVariantPrice * qty;
      pdpTotalEl.textContent = pdpFormatMoney(total);
      pdpTotalEl.classList.remove('pdp-price-pop');
      void pdpTotalEl.offsetWidth;
      pdpTotalEl.classList.add('pdp-price-pop');
    }

    /* Stock warning */
    var maxQty = pdpGetMaxQty();
    if (pdpStockWarning && maxQty !== Infinity) {
      if (qty >= maxQty && maxQty > 0) {
        pdpStockWarningText.textContent = 'Only ' + maxQty + ' available in stock';
        pdpStockWarning.style.display = '';
      } else if (maxQty === 0) {
        pdpStockWarningText.textContent = 'Out of stock';
        pdpStockWarning.style.display = '';
      } else {
        pdpStockWarning.style.display = 'none';
      }
    } else if (pdpStockWarning) {
      pdpStockWarning.style.display = 'none';
    }

    /* update free shipping badge */
    var pdpTotal = pdpCurrentVariantPrice * qty;
    pdpUpdateFreeShippingBadge(pdpTotal);
  }

  /* ── Qty stepper with stock limit ── */
  if (pdpQtyMinus && pdpQtyPlus && pdpQtyInput) {
    pdpQtyMinus.addEventListener('click', function() {
      var v = parseInt(pdpQtyInput.value, 10) || 1;
      if (v > 1) { pdpQtyInput.value = v - 1; pdpUpdateTotal(); }
    });
    pdpQtyPlus.addEventListener('click', function() {
      var v = parseInt(pdpQtyInput.value, 10) || 1;
      var maxQty = pdpGetMaxQty();
      if (v < maxQty) {
        pdpQtyInput.value = v + 1;
      }
      pdpUpdateTotal();
    });
  }

  /* ── Variant selector ── */
  var variantSelectors = document.querySelectorAll('.variant-selector');
  if (variantSelectors.length > 0 && typeof productVariants !== 'undefined') {
    variantSelectors.forEach(function(select) {
      select.addEventListener('change', function() {
        var selectedOptions = [];
        variantSelectors.forEach(function(sel) { selectedOptions.push(sel.value); });

        var matched = null;
        for (var i = 0; i < productVariants.length; i++) {
          var v = productVariants[i];
          var ok = true;
          for (var j = 0; j < selectedOptions.length; j++) {
            if (v.options[j] !== selectedOptions[j]) { ok = false; break; }
          }
          if (ok) { matched = v; break; }
        }

        if (matched) {
          var idInput = document.getElementById('selected-variant-id');
          if (idInput) idInput.value = matched.id;

          history.replaceState(null, '', window.location.pathname + '?variant=' + matched.id);

          pdpCurrentVariantPrice = matched.price;
          pdpCurrentVariantId = String(matched.id);

          /* Reset qty to 1 when variant changes */
          if (pdpQtyInput) pdpQtyInput.value = 1;

          if (pdpPriceEl) {
            pdpPriceEl.textContent = pdpFormatMoney(matched.price);
            pdpPriceEl.setAttribute('data-price', matched.price);
            pdpPriceEl.classList.remove('pdp-price-pop');
            void pdpPriceEl.offsetWidth;
            pdpPriceEl.classList.add('pdp-price-pop');
          }

          if (pdpCompareEl) {
            if (matched.compare_at_price && matched.compare_at_price > matched.price) {
              pdpCompareEl.textContent = pdpFormatMoney(matched.compare_at_price);
              pdpCompareEl.style.display = '';
            } else {
              pdpCompareEl.style.display = 'none';
            }
          }

          pdpUpdateTotal();

          if (pdpAddBtn) {
            if (matched.available) {
              pdpAddBtn.disabled = false;
              if (pdpAddText) pdpAddText.textContent = 'Add to Cart';
            } else {
              pdpAddBtn.disabled = true;
              if (pdpAddText) pdpAddText.textContent = 'Sold Out';
            }
          }

          /* Update main image to variant image */
          if (matched.featured_image && pdpMainImg) {
            var variantSrc = matched.featured_image.src;
            var variantZoom = matched.featured_image.zoom || matched.featured_image.src;
            var vWrap = document.getElementById('pdp-main-wrap');
            if (vWrap) vWrap.classList.add('pdp-loading');
            pdpMainImg.removeAttribute('srcset');
            pdpMainImg.src = variantSrc;
            pdpMainImg.setAttribute('data-zoom', variantZoom);
            pdpMainImg.onload = function() { if (vWrap) vWrap.classList.remove('pdp-loading'); };

            /* Activate matching thumb */
            if (pdpThumbs) {
              var allThumbs = pdpThumbs.querySelectorAll('.pdp-thumb');
              allThumbs.forEach(function(t, idx) {
                var df = t.getAttribute('data-full');
                if (df && df.indexOf(matched.featured_image.src.split('?')[0].split('/').pop().split('.')[0]) > -1) {
                  t.classList.add('active');
                  pdpCurrentIndex = idx;
                } else {
                  t.classList.remove('active');
                }
              });
            }
          }
        }
      });
    });
  }

  /* ─── Cart Money Format ─── */
  var cartMoneyFormatRaw = (window.amezoniCart && window.amezoniCart.moneyFormat) || '${{amount}}';
  var cartMoneyFormat = cartMoneyFormatRaw.replace(/<[^>]*>/g, '');

  function cartFormatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var amountComma = amount.replace('.', ',');
    var noDecimals = Math.round(cents / 100).toString();
    return cartMoneyFormat
      .replace('{{amount}}', amount)
      .replace('{{amount_with_comma_separator}}', amountComma)
      .replace('{{amount_no_decimals}}', noDecimals)
      .replace('{{amount_no_decimals_with_comma_separator}}', noDecimals);
  }

  /* ─── Cart AJAX (Auto-update quantities) ─── */
  var cartItemsContainer = document.getElementById('cart-items');
  if (cartItemsContainer) {
    var cartUpdating = false;
    var cartLiveRegion = document.getElementById('cart-live-region');

    function announceCart(message) {
      if (!cartLiveRegion) return;
      cartLiveRegion.textContent = '';
      setTimeout(function() { cartLiveRegion.textContent = message; }, 20);
    }

    function triggerPricePop(el) {
      el.classList.remove('price-pop');
      void el.offsetWidth;
      el.classList.add('price-pop');
      setTimeout(function() { el.classList.remove('price-pop'); }, 350);
    }

    function updateFreeShippingBar(cartTotalCents) {
      var bar = document.getElementById('free-shipping-bar');
      if (!bar) return;

      var threshold = (window.amezoniCart && window.amezoniCart.freeShippingThreshold) || 0;
      if (threshold <= 0) return;

      var fillEl = document.getElementById('free-shipping-fill');
      var textEl = document.getElementById('free-shipping-text');
      var truckIcon = bar.querySelector('.free-shipping-icon--truck');
      var checkIcon = bar.querySelector('.free-shipping-icon--check');

      var pct = Math.min((cartTotalCents / threshold) * 100, 100);
      fillEl.style.width = pct + '%';

      if (cartTotalCents >= threshold) {
        bar.classList.add('achieved');
        if (truckIcon) truckIcon.style.display = 'none';
        if (checkIcon) checkIcon.style.display = '';
        textEl.textContent = bar.getAttribute('data-achieved-msg') || 'You qualify for FREE shipping!';
      } else {
        bar.classList.remove('achieved');
        if (truckIcon) truckIcon.style.display = '';
        if (checkIcon) checkIcon.style.display = 'none';
        var remaining = cartFormatMoney(threshold - cartTotalCents);
        var template = bar.getAttribute('data-remaining-msg') || 'Spend [amount] more for FREE shipping!';
        textEl.textContent = template.replace('[amount]', remaining);
      }
    }

    var shippingEstimator = document.querySelector('[data-cart-shipping-estimator]');
    var shippingEstimateRequestId = 0;

    function cartShippingEndpoint(path) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (root.charAt(root.length - 1) !== '/') root += '/';
      return root + path;
    }

    function parseShippingResponse(response) {
      return response.text().then(function(text) {
        if (!text) return null;
        try {
          return JSON.parse(text);
        } catch (e) {
          return null;
        }
      });
    }

    function setShippingStatus(message, isError) {
      if (!shippingEstimator) return;
      var status = shippingEstimator.querySelector('[data-cart-shipping-status]');
      if (!status) return;
      var statusMessage = message || '';
      status.textContent = statusMessage;
      status.hidden = !statusMessage;
      status.classList.toggle('is-error', !!isError);
    }

    function setShippingFineprintVisible(isVisible) {
      if (!shippingEstimator) return;
      var fineprint = shippingEstimator.querySelector('[data-cart-shipping-fineprint]');
      if (!fineprint) return;
      fineprint.hidden = !isVisible;
    }

    function clearShippingResults() {
      if (!shippingEstimator) return;
      var results = shippingEstimator.querySelector('[data-cart-shipping-results]');
      if (!results) return;
      results.hidden = true;
      results.replaceChildren();
      setShippingFineprintVisible(false);
    }

    function resetShippingEstimator(message) {
      if (!shippingEstimator) return;
      shippingEstimateRequestId += 1;
      clearShippingResults();
      setShippingStatus(message || '', false);
    }

    function formatShippingRatePrice(rate) {
      if (rate.price === undefined || rate.price === null) return '';
      var numericPrice = Number(String(rate.price).replace(/,/g, ''));
      if (!isNaN(numericPrice)) {
        return cartFormatMoney(Math.round(numericPrice * 100));
      }
      return String(rate.price);
    }

    function getSaoPauloTimeParts(date) {
      try {
        var formatter = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Sao_Paulo',
          weekday: 'short',
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23'
        });
        var parts = formatter.formatToParts(date || new Date());
        var values = {};
        parts.forEach(function(part) {
          values[part.type] = part.value;
        });
        var weekdays = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
        var hour = Number(values.hour);
        if (hour === 24) hour = 0;
        return {
          day: weekdays[values.weekday] !== undefined ? weekdays[values.weekday] : (date || new Date()).getDay(),
          minutes: hour * 60 + Number(values.minute || 0)
        };
      } catch (e) {
        var fallbackDate = date || new Date();
        return {
          day: fallbackDate.getDay(),
          minutes: fallbackDate.getHours() * 60 + fallbackDate.getMinutes()
        };
      }
    }

    function getDaysUntilFedExPickup() {
      var saoPauloTime = getSaoPauloTimeParts(new Date());
      var pickupDay = 3;
      var cutoffMinutes = 9 * 60;
      var daysUntilPickup = (pickupDay - saoPauloTime.day + 7) % 7;
      if (daysUntilPickup === 0 && saoPauloTime.minutes >= cutoffMinutes) {
        daysUntilPickup = 7;
      }
      return daysUntilPickup;
    }

    function isUsOrCanada(country) {
      var normalized = normalizeShippingText(country).replace(/[^a-z]/g, '');
      return normalized === 'us' ||
        normalized === 'usa' ||
        normalized === 'unitedstates' ||
        normalized === 'unitedstatesofamerica' ||
        normalized === 'ca' ||
        normalized === 'canada';
    }

    function getFallbackTransitDays(country) {
      return isUsOrCanada(country) ? [2, 5] : [3, 7];
    }

    function getNativeTransitDays(rate) {
      if (!Array.isArray(rate.delivery_days) || rate.delivery_days.length < 2) return null;
      var minDays = Number(rate.delivery_days[0]);
      var maxDays = Number(rate.delivery_days[1]);
      if (!isFinite(minDays) || !isFinite(maxDays)) return null;
      if (maxDays <= 0) return null;
      minDays = Math.max(0, Math.floor(minDays));
      maxDays = Math.max(minDays, Math.ceil(maxDays));
      return [minDays, maxDays];
    }

    function formatDeliveryEstimate(minDays, maxDays) {
      if (!shippingEstimator) return '';
      if (minDays === maxDays) {
        var singleTemplate = shippingEstimator.getAttribute('data-delivery-estimate-single-text') || 'Estimated delivery: [days] calendar days';
        return singleTemplate.replace('[days]', minDays);
      }
      var rangeTemplate = shippingEstimator.getAttribute('data-delivery-estimate-text') || 'Estimated delivery: [min]-[max] calendar days';
      return rangeTemplate.replace('[min]', minDays).replace('[max]', maxDays);
    }

    function getShippingDeliveryEstimate(rate, country) {
      var transitDays = getNativeTransitDays(rate) || getFallbackTransitDays(country);
      var pickupWaitDays = getDaysUntilFedExPickup();
      return formatDeliveryEstimate(transitDays[0] + pickupWaitDays, transitDays[1] + pickupWaitDays);
    }

    function renderShippingRates(rates, destinationCountry) {
      if (!shippingEstimator) return;
      var results = shippingEstimator.querySelector('[data-cart-shipping-results]');
      if (!results) return;

      results.replaceChildren();
      var list = document.createElement('ul');
      list.className = 'cart-shipping-rates';

      rates.forEach(function(rate) {
        var item = document.createElement('li');
        item.className = 'cart-shipping-rate';

        var name = document.createElement('span');
        name.className = 'cart-shipping-rate__name';
        name.textContent = rate.presentment_name || rate.name || rate.code || 'Shipping';

        var price = document.createElement('span');
        price.className = 'cart-shipping-rate__price';
        price.textContent = formatShippingRatePrice(rate);

        item.appendChild(name);
        item.appendChild(price);

        var metaParts = [];
        var deliveryEstimate = getShippingDeliveryEstimate(rate, destinationCountry);
        if (deliveryEstimate) metaParts.push(deliveryEstimate);
        if (rate.description) metaParts.push(rate.description);
        if (metaParts.length) {
          var meta = document.createElement('span');
          meta.className = 'cart-shipping-rate__meta';
          meta.textContent = metaParts.join(' · ');
          item.appendChild(meta);
        }

        list.appendChild(item);
      });

      results.appendChild(list);
      results.hidden = false;
      setShippingFineprintVisible(true);
    }

    function normalizeShippingText(text) {
      var normalized = String(text || '').toLowerCase();
      if (normalized.normalize) {
        normalized = normalized.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      }
      return normalized.trim();
    }

    function parseCountryProvinces(option) {
      var provinces = option.getAttribute('data-provinces') || '[]';
      try {
        return JSON.parse(provinces);
      } catch (e) {
        return [];
      }
    }

    function initShippingCountryFields(form) {
      var countrySelect = shippingEstimator.querySelector('[data-cart-country-select]');
      var countryButton = shippingEstimator.querySelector('[data-cart-country-button]');
      var countryLabel = shippingEstimator.querySelector('[data-cart-country-label]');
      var countryList = shippingEstimator.querySelector('[data-cart-country-list]');
      var provinceSelect = shippingEstimator.querySelector('[data-cart-province-select]');
      var provinceButton = shippingEstimator.querySelector('[data-cart-province-button]');
      var provinceLabel = shippingEstimator.querySelector('[data-cart-province-label]');
      var provinceList = shippingEstimator.querySelector('[data-cart-province-list]');
      var zipInput = shippingEstimator.querySelector('[data-cart-zip-input]');
      if (!countrySelect || !countryButton || !countryLabel || !countryList || !provinceSelect || !provinceButton || !provinceLabel || !provinceList) return;

      var countryPlaceholder = shippingEstimator.getAttribute('data-country-placeholder') || 'Select country';
      var provincePlaceholder = shippingEstimator.getAttribute('data-province-placeholder') || 'Select state / province';
      var provinceDisabled = shippingEstimator.getAttribute('data-province-disabled') || 'Select country first';
      var provinceEmpty = shippingEstimator.getAttribute('data-province-empty') || 'No state / province required';
      var provinceRequired = shippingEstimator.getAttribute('data-province-required') || 'Select a state / province';
      var countryRequired = shippingEstimator.getAttribute('data-country-required') || 'Select a country';
      var countryActiveIndex = -1;
      var provinceActiveIndex = -1;
      var selectedCountry = null;
      var currentProvinces = [];
      var countries = Array.prototype.slice.call(countrySelect.options).map(function(option) {
        var label = option.textContent.trim();
        return {
          value: option.value,
          label: label,
          search: normalizeShippingText(label + ' ' + option.value),
          provinces: parseCountryProvinces(option)
        };
      }).filter(function(country) {
        return country.value && country.value !== '---' && country.label !== '---';
      });
      countrySelect.value = '';

      function closeMenu(button, list) {
        list.hidden = true;
        button.setAttribute('aria-expanded', 'false');
        button.removeAttribute('aria-activedescendant');
      }

      function closeCountryMenu() {
        closeMenu(countryButton, countryList);
        countryActiveIndex = -1;
      }

      function closeProvinceMenu() {
        closeMenu(provinceButton, provinceList);
        provinceActiveIndex = -1;
      }

      function closeOtherMenus(menu) {
        if (menu !== 'country') closeCountryMenu();
        if (menu !== 'province') closeProvinceMenu();
      }

      function setActiveMenuOption(button, list, index) {
        var options = list.querySelectorAll('[role="option"]');
        options.forEach(function(option) {
          option.classList.remove('is-active');
          option.setAttribute('aria-selected', 'false');
        });

        if (!options.length) {
          button.removeAttribute('aria-activedescendant');
          return -1;
        }

        var nextIndex = Math.max(0, Math.min(index, options.length - 1));
        var activeOption = options[nextIndex];
        activeOption.classList.add('is-active');
        activeOption.setAttribute('aria-selected', 'true');
        button.setAttribute('aria-activedescendant', activeOption.id);
        activeOption.scrollIntoView({ block: 'nearest' });
        return nextIndex;
      }

      function openCountryMenu() {
        renderCountryMenu();
        closeOtherMenus('country');
        countryList.hidden = false;
        countryButton.setAttribute('aria-expanded', 'true');
      }

      function openProvinceMenu() {
        if (provinceButton.disabled) return;
        renderProvinceMenu();
        closeOtherMenus('province');
        provinceList.hidden = false;
        provinceButton.setAttribute('aria-expanded', 'true');
      }

      function renderCountryMenu() {
        countryList.replaceChildren();

        countries.forEach(function(country, index) {
          var item = document.createElement('li');
          var option = document.createElement('button');
          option.type = 'button';
          option.id = 'cart-shipping-country-option-' + index;
          option.className = 'cart-shipping-select__option';
          option.setAttribute('role', 'option');
          option.setAttribute('aria-selected', selectedCountry && selectedCountry.value === country.value ? 'true' : 'false');
          option.textContent = country.label;
          option.addEventListener('mousedown', function(e) { e.preventDefault(); });
          option.addEventListener('click', function() {
            selectCountry(country, { close: true });
            countryButton.focus();
          });
          item.appendChild(option);
          countryList.appendChild(item);
        });
      }

      function renderProvinceMenu() {
        provinceList.replaceChildren();

        currentProvinces.forEach(function(province, index) {
          var item = document.createElement('li');
          var option = document.createElement('button');
          option.type = 'button';
          option.id = 'cart-shipping-province-option-' + index;
          option.className = 'cart-shipping-select__option';
          option.setAttribute('role', 'option');
          option.setAttribute('aria-selected', provinceSelect.value === province.value ? 'true' : 'false');
          option.textContent = province.label;
          option.addEventListener('mousedown', function(e) { e.preventDefault(); });
          option.addEventListener('click', function() {
            selectProvince(province.value, { close: true });
            provinceButton.focus();
          });
          item.appendChild(option);
          provinceList.appendChild(item);
        });
      }

      function setProvinceOptions(provinces, selectedProvince) {
        currentProvinces = provinces.map(function(province) {
          var value = Array.isArray(province) ? province[0] : province;
          var label = Array.isArray(province) ? (province[1] || province[0]) : province;
          return {
            value: String(value || label || ''),
            label: String(label || value || '')
          };
        });

        provinceSelect.replaceChildren();
        provinceSelect.required = false;
        closeProvinceMenu();

        if (!currentProvinces.length) {
          var emptyOption = document.createElement('option');
          emptyOption.value = '';
          emptyOption.textContent = selectedCountry ? provinceEmpty : provinceDisabled;
          provinceSelect.appendChild(emptyOption);
          provinceSelect.disabled = true;
          provinceButton.disabled = true;
          provinceButton.parentElement.classList.add('is-disabled');
          provinceLabel.textContent = selectedCountry ? provinceEmpty : provinceDisabled;
          provinceList.replaceChildren();
          return;
        }

        var placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = provincePlaceholder;
        provinceSelect.appendChild(placeholder);

        currentProvinces.forEach(function(province) {
          var option = document.createElement('option');
          option.value = province.value;
          option.textContent = province.label;
          provinceSelect.appendChild(option);
        });

        provinceSelect.disabled = false;
        provinceButton.disabled = false;
        provinceButton.parentElement.classList.remove('is-disabled');
        provinceLabel.textContent = provincePlaceholder;

        if (selectedProvince) {
          var match = currentProvinces.find(function(province) {
            return normalizeShippingText(province.value) === normalizeShippingText(selectedProvince) ||
              normalizeShippingText(province.label) === normalizeShippingText(selectedProvince);
          });
          if (match) selectProvince(match.value, { silent: true });
        }
      }

      function findCountry(value) {
        var normalized = normalizeShippingText(value);
        if (!normalized) return null;
        return countries.find(function(country) {
          return normalizeShippingText(country.value) === normalized ||
            normalizeShippingText(country.label) === normalized;
        }) || null;
      }

      function selectCountry(country, options) {
        options = options || {};
        selectedCountry = country;
        countrySelect.value = country.value;
        countryLabel.textContent = country.label;
        setProvinceOptions(country.provinces, options.province || '');
        if (options.close) closeCountryMenu();
        if (!options.silent) resetShippingEstimator('');
      }

      function selectProvince(value, options) {
        options = options || {};
        var match = currentProvinces.find(function(province) {
          return province.value === value;
        });
        provinceSelect.value = match ? match.value : '';
        provinceLabel.textContent = match ? match.label : provincePlaceholder;
        if (options.close) closeProvinceMenu();
        if (!options.silent) resetShippingEstimator('');
      }

      function applyDetectedCountry() {
        if (shippingEstimator.getAttribute('data-has-customer-address') === 'true') return;
        if (zipInput && zipInput.value.trim()) return;
        if (!window.fetch) return;

        var url = cartShippingEndpoint('browsing_context_suggestions.json') + '?country[enabled]=true';
        if (window.Shopify && window.Shopify.country) {
          url += '&country[exclude]=' + encodeURIComponent(window.Shopify.country);
        }

        fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function(response) {
            if (!response.ok) throw new Error('Localization unavailable');
            return response.json();
          })
          .then(function(data) {
            var detected = data && data.detected_values && data.detected_values.country;
            if (!detected && data && data.suggestions && data.suggestions[0] && data.suggestions[0].parts) {
              detected = data.suggestions[0].parts.country;
            }
            if (!detected) return;

            var match = findCountry(detected.name);
            if (match) selectCountry(match, { silent: true, close: true });
          })
          .catch(function() {});
      }

      setProvinceOptions([], '');
      countryLabel.textContent = countryPlaceholder;

      var initialCountry = shippingEstimator.getAttribute('data-initial-country') || '';
      var initialProvince = shippingEstimator.getAttribute('data-initial-province') || '';
      var initialMatch = findCountry(initialCountry);
      if (initialMatch) {
        selectCountry(initialMatch, { province: initialProvince, silent: true, close: true });
      }

      countryButton.addEventListener('click', function() {
        if (countryList.hidden) {
          openCountryMenu();
        } else {
          closeCountryMenu();
        }
      });

      countryButton.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          if (countryList.hidden) openCountryMenu();
          countryActiveIndex = setActiveMenuOption(countryButton, countryList, countryActiveIndex + 1);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          if (countryList.hidden) openCountryMenu();
          var countryOptions = countryList.querySelectorAll('[role="option"]');
          countryActiveIndex = setActiveMenuOption(countryButton, countryList, countryActiveIndex <= 0 ? countryOptions.length - 1 : countryActiveIndex - 1);
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (countryList.hidden) {
            openCountryMenu();
          } else if (countries[countryActiveIndex]) {
            selectCountry(countries[countryActiveIndex], { close: true });
          }
        } else if (e.key === 'Escape') {
          closeCountryMenu();
        }
      });

      provinceButton.addEventListener('click', function() {
        if (provinceList.hidden) {
          openProvinceMenu();
        } else {
          closeProvinceMenu();
        }
      });

      provinceButton.addEventListener('keydown', function(e) {
        if (provinceButton.disabled) return;
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          if (provinceList.hidden) openProvinceMenu();
          provinceActiveIndex = setActiveMenuOption(provinceButton, provinceList, provinceActiveIndex + 1);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          if (provinceList.hidden) openProvinceMenu();
          var provinceOptions = provinceList.querySelectorAll('[role="option"]');
          provinceActiveIndex = setActiveMenuOption(provinceButton, provinceList, provinceActiveIndex <= 0 ? provinceOptions.length - 1 : provinceActiveIndex - 1);
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (provinceList.hidden) {
            openProvinceMenu();
          } else if (currentProvinces[provinceActiveIndex]) {
            selectProvince(currentProvinces[provinceActiveIndex].value, { close: true });
          }
        } else if (e.key === 'Escape') {
          closeProvinceMenu();
        }
      });

      document.addEventListener('click', function(e) {
        if (!countryButton.parentElement.contains(e.target)) closeCountryMenu();
        if (!provinceButton.parentElement.contains(e.target)) closeProvinceMenu();
      });

      form.addEventListener('cart-shipping-validate', function(e) {
        if (!countrySelect.value) {
          e.preventDefault();
          setShippingStatus(countryRequired, true);
          countryButton.focus();
          return;
        }

        if (!provinceSelect.disabled && !provinceSelect.value) {
          e.preventDefault();
          setShippingStatus(provinceRequired, true);
          provinceButton.focus();
        }
      });

      provinceSelect.addEventListener('change', function() {
        var selected = currentProvinces.find(function(province) {
          return province.value === provinceSelect.value;
        });
        provinceLabel.textContent = selected ? selected.label : provincePlaceholder;
        resetShippingEstimator('');
      });

      countrySelect.addEventListener('change', function() {
        var match = findCountry(countrySelect.value);
        if (match) {
          selectCountry(match, { silent: true });
        }
        resetShippingEstimator('');
      });

      if (zipInput) {
        zipInput.addEventListener('change', function() {
          resetShippingEstimator('');
        });
      }

      applyDetectedCountry();
    }

    function pollShippingRates(queryString, requestId, attempt, destinationCountry) {
      return fetch(cartShippingEndpoint('cart/async_shipping_rates.json') + '?' + queryString, {
        headers: { 'Accept': 'application/json' }
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Shipping rates unavailable');
        return parseShippingResponse(response);
      })
      .then(function(data) {
        if (requestId !== shippingEstimateRequestId) return;

        if (data && Array.isArray(data.shipping_rates)) {
          if (data.shipping_rates.length) {
            renderShippingRates(data.shipping_rates, destinationCountry);
            setShippingStatus(shippingEstimator.getAttribute('data-ready-text') || '', false);
          } else {
            clearShippingResults();
            setShippingStatus(shippingEstimator.getAttribute('data-empty-text') || 'No shipping rates available for this address.', true);
          }
          return null;
        }

        if (attempt >= 7) {
          clearShippingResults();
          setShippingStatus(shippingEstimator.getAttribute('data-timeout-text') || 'Rates are taking longer than expected. Please try again.', true);
          return null;
        }

        return new Promise(function(resolve) {
          setTimeout(resolve, 650 + attempt * 250);
        }).then(function() {
          return pollShippingRates(queryString, requestId, attempt + 1, destinationCountry);
        });
      })
      .catch(function() {
        if (requestId !== shippingEstimateRequestId) return;
        clearShippingResults();
        setShippingStatus(shippingEstimator.getAttribute('data-error-text') || 'Shipping rates could not be calculated right now.', true);
      });
    }

    function initShippingEstimator() {
      if (!shippingEstimator) return;

      var form = shippingEstimator.querySelector('[data-cart-shipping-form]');
      if (!form) return;

      initShippingCountryFields(form);

      form.addEventListener('submit', function(e) {
        e.preventDefault();

        var shippingValidation = new Event('cart-shipping-validate', { cancelable: true });
        form.dispatchEvent(shippingValidation);
        if (shippingValidation.defaultPrevented) {
          return;
        }

        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        var formData = new FormData(form);
        var zip = String(formData.get('rate_postal') || '').trim();
        var country = String(formData.get('rate_country') || '').trim();
        var province = String(formData.get('rate_region') || '').trim();
        var query = new URLSearchParams();
        query.set('shipping_address[zip]', zip);
        query.set('shipping_address[country]', country);
        if (province) query.set('shipping_address[province]', province);

        var button = form.querySelector('button[type="submit"]');
        var requestId = shippingEstimateRequestId + 1;
        shippingEstimateRequestId = requestId;

        clearShippingResults();
        setShippingStatus(shippingEstimator.getAttribute('data-loading-text') || 'Calculating shipping rates...', false);

        if (button) {
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
        }

        fetch(cartShippingEndpoint('cart/prepare_shipping_rates.json') + '?' + query.toString(), {
          method: 'POST',
          headers: { 'Accept': 'application/json' }
        })
        .then(function(response) {
          if (!response.ok && response.status !== 202) throw new Error('Shipping rate preparation failed');
          return pollShippingRates(query.toString(), requestId, 0, country);
        })
        .catch(function() {
          if (requestId !== shippingEstimateRequestId) return;
          clearShippingResults();
          setShippingStatus(shippingEstimator.getAttribute('data-error-text') || 'Shipping rates could not be calculated right now.', true);
        })
        .finally(function() {
          if (requestId !== shippingEstimateRequestId) return;
          if (button) {
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }
        });
      });
    }

    function updateCartTotals(cart) {
      var totalEl = document.querySelector('.cart-total-price');
      if (totalEl) {
        totalEl.textContent = cartFormatMoney(cart.total_price);
        triggerPricePop(totalEl);
      }

      var countEl = document.querySelector('.cart-count');
      if (countEl) {
        countEl.textContent = cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '');
      }

      var badge = document.querySelector('.navbar-cart-count');
      if (badge) {
        if (cart.item_count > 0) {
          badge.textContent = cart.item_count;
          badge.style.display = '';
        } else {
          badge.style.display = 'none';
        }
      }

      updateFreeShippingBar(cart.total_price);
      resetShippingEstimator(shippingEstimator ? shippingEstimator.getAttribute('data-recalculate-text') : '');
    }

    function updateCartItem(key, requestedQty, el) {
      if (cartUpdating) return;
      cartUpdating = true;
      el.classList.add('cart-item-loading');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: requestedQty })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (requestedQty === 0) {
          var removedTitle = el.querySelector('.cart-item-title');
          el.classList.add('cart-item-removing');
          setTimeout(function() {
            el.remove();
            updateCartTotals(cart);
            announceCart((removedTitle ? removedTitle.textContent.trim() : 'Item') + ' removed from cart.');
            if (cart.item_count === 0) location.reload();
          }, 400);
          cartUpdating = false;
          return;
        }

        var updatedItem = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === key) {
            updatedItem = cart.items[i];
            break;
          }
        }

        if (updatedItem) {
          var qtyEl = el.querySelector('.cart-qty-value');
          qtyEl.textContent = updatedItem.quantity;
          qtyEl.setAttribute('data-qty', updatedItem.quantity);
          qtyEl.classList.add('cart-qty-flash');
          setTimeout(function() { qtyEl.classList.remove('cart-qty-flash'); }, 300);

          var linePriceEl = el.querySelector('.cart-item-line-price');
          linePriceEl.textContent = cartFormatMoney(updatedItem.line_price);
          linePriceEl.setAttribute('data-price', updatedItem.line_price);
          triggerPricePop(linePriceEl);

          var warning = el.querySelector('.cart-item-stock-warning');
          if (updatedItem.quantity < requestedQty) {
            warning.querySelector('span').textContent = 'Only ' + updatedItem.quantity + ' available';
            warning.style.display = 'flex';
            announceCart('Quantity updated to ' + updatedItem.quantity + '. Only ' + updatedItem.quantity + ' available.');
          } else {
            warning.style.display = 'none';
            announceCart('Quantity updated to ' + updatedItem.quantity + '.');
          }
        }

        el.classList.remove('cart-item-loading');
        updateCartTotals(cart);
        cartUpdating = false;
      })
      .catch(function() {
        el.classList.remove('cart-item-loading');
        cartUpdating = false;
      });
    }

    cartItemsContainer.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-action]');
      if (!btn) return;

      var item = btn.closest('.cart-item');
      if (!item) return;

      var key = item.getAttribute('data-key');
      var action = btn.getAttribute('data-action');
      var qtyEl = item.querySelector('.cart-qty-value');
      var currentQty = parseInt(qtyEl.getAttribute('data-qty'), 10);

      if (action === 'decrease') {
        updateCartItem(key, currentQty > 1 ? currentQty - 1 : 0, item);
      } else if (action === 'increase') {
        updateCartItem(key, currentQty + 1, item);
      } else if (action === 'remove') {
        updateCartItem(key, 0, item);
      }
    });

    initShippingEstimator();
  }

});


/* ═══════════════════════════════════════════════════════════
   NEW FEATURES — Audit Improvements
   ═══════════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function() {
  /* ─── Navbar Cart Count Badge Update ─── */
  (function() {
    var badge = document.querySelector('.navbar-cart-count');
    if (!badge) return;

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (cart.item_count > 0) {
          badge.textContent = cart.item_count;
          badge.style.display = '';
        } else {
          badge.style.display = 'none';
        }
      })
      .catch(function() {});
  })();

  /* ─── Quick add to cart from product cards (lc-pcard-actions) ─── */
  (function() {
    function swapFormForInCart(form) {
      if (!form || !form.parentNode) return;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var inCart = document.createElement('a');
      inCart.href = root + 'cart';
      inCart.className = 'lc-pcard-actions__btn lc-pcard-actions__btn--in-cart';
      inCart.textContent = 'In cart';
      inCart.setAttribute('aria-label', 'View cart');
      form.replaceWith(inCart);
    }

    // Pulls cart state once and applies it to all cart-aware UI: navbar badge
    // + any quick-add form whose variant is at/above its declared cap. Runs on
    // cart:updated (post-add, drawer changes, PDP) and bfcache restore.
    function syncCartUI() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var badge = document.querySelector('.navbar-cart-count');
          if (badge) {
            if (cart.item_count > 0) {
              badge.textContent = cart.item_count;
              badge.style.display = '';
            } else {
              badge.style.display = 'none';
            }
          }
          var byVariant = {};
          (cart.items || []).forEach(function(i) { byVariant[i.variant_id] = i.quantity; });
          document.querySelectorAll('[data-lc-cart-add][data-max-qty]').forEach(function(form) {
            var maxQty = parseInt(form.getAttribute('data-max-qty'), 10);
            var input = form.querySelector('input[name="id"]');
            var vid = input && input.value;
            if (!vid || !maxQty) return;
            if ((byVariant[vid] || 0) >= maxQty) swapFormForInCart(form);
          });
        })
        .catch(function() {});
    }

    // On the cart page, re-fetch the rendered main-cart section and swap in
    // fresh content so adds from cross-sell cards reflect immediately without
    // a page reload. The .cart-section guard makes this a no-op everywhere
    // else. We replace innerHTML of stable containers (#cart-items, the
    // cross-sell grid) rather than the containers themselves, so the click
    // delegate bound to #cart-items in the cart AJAX block stays intact.
    // Shopify's Section Rendering API returns the rendered section wrapped in
    // <div id="shopify-section-...">; the cart section selectors are
    // descendants of that wrapper.
    function refreshCartPageContent() {
      if (!document.querySelector('.cart-section')) return;
      fetch('/cart?section_id=main-cart', { headers: { 'Accept': 'text/html' } })
        .then(function(r) { return r.ok ? r.text() : Promise.reject(new Error('section fetch ' + r.status)); })
        .then(function(html) {
          var temp = document.createElement('div');
          temp.innerHTML = html;

          var newCart = temp.querySelector('.cart-section');
          if (!newCart) return; // template structure mismatch — bail safely

          // If the cart just emptied, swap the whole section so the empty
          // state renders correctly. Re-init isn't needed since the click
          // delegate's target no longer exists.
          var nowEmpty = !newCart.querySelector('#cart-items');
          var wasEmpty = !document.getElementById('cart-items');
          if (nowEmpty || wasEmpty) {
            var current = document.querySelector('.cart-section');
            if (current) current.replaceWith(newCart);
            return;
          }

          // Items list — replace innerHTML, keep container + its click handler
          var newItems = newCart.querySelector('#cart-items');
          var currentItems = document.getElementById('cart-items');
          if (newItems && currentItems) currentItems.innerHTML = newItems.innerHTML;

          // Header count ("N items")
          var newCount = newCart.querySelector('.cart-count');
          var currentCount = document.querySelector('.cart-count');
          if (newCount && currentCount) currentCount.textContent = newCount.textContent;

          // Subtotal (text + data-total + pulse animation)
          var newTotal = newCart.querySelector('.cart-total-price');
          var currentTotal = document.querySelector('.cart-total-price');
          if (newTotal && currentTotal) {
            currentTotal.textContent = newTotal.textContent;
            var dataTotal = newTotal.getAttribute('data-total');
            if (dataTotal !== null) currentTotal.setAttribute('data-total', dataTotal);
            currentTotal.classList.remove('price-pop');
            void currentTotal.offsetWidth;
            currentTotal.classList.add('price-pop');
          }

          // Free-shipping bar (replace whole element so threshold/progress refresh)
          var newFsBar = newCart.querySelector('.free-shipping-bar');
          var currentFsBar = document.querySelector('.free-shipping-bar');
          if (newFsBar && currentFsBar) currentFsBar.replaceWith(newFsBar);

          // Cross-sell grid (just-added product is filtered out server-side)
          var newCross = newCart.querySelector('.cart-cross-sell-grid');
          var currentCross = document.querySelector('.cart-cross-sell-grid');
          if (newCross && currentCross) currentCross.innerHTML = newCross.innerHTML;
        })
        .catch(function() {});
    }

    document.addEventListener('cart:updated', function() {
      syncCartUI();
      refreshCartPageContent();
    });
    window.addEventListener('pageshow', function(e) {
      if (!e.persisted) return;
      // bfcache restore: page DOM may misrepresent current cart state. Reload
      // when (a) any "In cart" UI is present (link can't be reverted to form
      // without rebuilding HTML) or (b) we're on a PDP — qty stepper max attr
      // or hidden qty may be stale relative to cart_qty for this variant if
      // user changed qty in /cart and pressed Back. PDP is the conversion
      // surface; never trust stale state.
      if (
        document.body.classList.contains('template-product') ||
        document.querySelector('.pdp-add-btn--in-cart, .lc-pcard-actions__btn--in-cart')
      ) {
        window.location.reload();
        return;
      }
      syncCartUI();
    });

    document.addEventListener('submit', function(e) {
      var form = e.target.closest('[data-lc-cart-add]');
      if (!form) return;
      e.preventDefault();

      var btn = form.querySelector('button[type="submit"]');
      if (!btn) return;
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      })
        .then(function(res) {
          if (!res.ok) throw new Error('Add failed (' + res.status + ')');
          return res.json();
        })
        .then(function(item) {
          btn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:updated'));

          // /cart/add.js returns the line item; .quantity is cumulative qty in cart for this line.
          // When the form had a hard cap (data-max-qty), swap form for "In cart" link if we hit it.
          // syncCartUI() fired via cart:updated may also swap; swapFormForInCart guards against
          // double-swap via parentNode check.
          var maxQty = parseInt(form.getAttribute('data-max-qty') || '0', 10);
          if (maxQty > 0 && item && typeof item.quantity === 'number' && item.quantity >= maxQty) {
            setTimeout(function() { swapFormForInCart(form); }, 800);
          } else {
            setTimeout(function() {
              btn.disabled = false;
              btn.textContent = originalText;
            }, 1500);
          }
        })
        .catch(function(err) {
          btn.textContent = 'Error';
          setTimeout(function() {
            btn.disabled = false;
            btn.textContent = originalText;
          }, 1500);
          console.error('[lc-pcard-actions] cart add failed:', err);
        });
    });
  })();

});

/* ═══════════════════════════════════════════════
   video-media — Custom Element (standalone player)
   ═══════════════════════════════════════════════ */
(function() {
  'use strict';

  function loadScript(src) {
    return new Promise(function(resolve, reject) {
      if (document.querySelector('script[src="' + src + '"]')) { resolve(); return; }
      var s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function inView(el, callback) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var cleanup = callback();
          if (typeof cleanup === 'function') observer._cleanup = cleanup;
        } else if (observer._cleanup) {
          observer._cleanup();
        }
      });
    }, { rootMargin: '0px 0px 50px 0px' });
    observer.observe(el);
    return observer;
  }

  var ytResolve;
  var onYouTubePromise = new Promise(function(resolve) { ytResolve = resolve; });
  if (window.YT && window.YT.Player) { ytResolve(); }
  var origCb = window.onYouTubeIframeAPIReady;
  window.onYouTubeIframeAPIReady = function() { if (origCb) origCb(); ytResolve(); };

  class BaseMedia extends HTMLElement {
    constructor() {
      super();
      this.player = null;
      this.pausedByUser = false;
      this.playingWhenLastViewed = false;
    }
    connectedCallback() {
      if (!this.hasAttribute('defer-hydration')) this.hydrate();
    }
    async hydrate() {
      var self = this;
      var playerTarget = this.getPlayerTarget();
      var handler = {
        get: function(target, prop) {
          return async function() {
            var resolved = await target;
            self.playerHandler(resolved, prop);
          };
        }
      };
      this.player = new Proxy(playerTarget, handler);
      this.setupInViewHandler();
    }
    setupInViewHandler() {
      var self = this;
      inView(this, function() {
        if ((self.autoplay && !self.pausedByUser) || self.playingWhenLastViewed) self.play();
        return function() {
          self.playingWhenLastViewed = self.playing;
          self.pause();
        };
      });
    }
    static get observedAttributes() { return ['defer-hydration', 'playing']; }
    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'defer-hydration' && newValue === null) this.hydrate();
      else if (name === 'playing') {
        if (oldValue === null && newValue === '') this.dispatchEvent(new CustomEvent('media:play', { bubbles: true }));
        else if (newValue === null) this.dispatchEvent(new CustomEvent('media:pause', { bubbles: true }));
      }
    }
    play() {
      this.pausedByUser = false;
      if (this.playing) return;
      if (this.player) this.player.play();
      this.playingWhenLastViewed = true;
    }
    pause() {
      this.pausedByUser = true;
      if (!this.playing) return;
      if (this.player) this.player.pause();
    }
    get playing() { return this.hasAttribute('playing'); }
    get autoplay() { return this.hasAttribute('autoplay'); }
  }

  class VideoMedia extends BaseMedia {
    connectedCallback() {
      super.connectedCallback();
      this.addEventListener('click', this._togglePlay.bind(this));
    }
    _togglePlay() {
      this.playing ? this.pause() : this.play();
    }
    getPlayerTarget() {
      this.setAttribute('loaded', '');
      return this.host ? this.setupThirdPartyVideoElement() : this.setupNativeVideoElement();
    }
    playerHandler(target, prop) {
      if (this.host === 'youtube') {
        prop === 'play' ? target.playVideo() : target.pauseVideo();
      } else {
        target[prop]();
      }
    }
    async setupThirdPartyVideoElement() {
      var template = this.querySelector('template');
      if (template) template.replaceWith(template.content.firstElementChild.cloneNode(true));
      return this.host === 'youtube' ? await this.setupYouTubePlayer() : await this.setupVimeoPlayer();
    }
    setupNativeVideoElement() {
      var self = this;
      var video = this.querySelector('video');
      if (!video) return Promise.resolve(null);
      video.addEventListener('play', function() { self.setAttribute('playing', ''); });
      video.addEventListener('pause', function() { if (video.paused && !video.seeking) self.removeAttribute('playing'); });
      return video;
    }
    setupYouTubePlayer() {
      var self = this;
      return new Promise(async function(resolve) {
        if (!window.YT || !window.YT.Player) await loadScript('https://www.youtube.com/iframe_api');
        await onYouTubePromise;
        var player = new YT.Player(self.querySelector('iframe'), {
          events: {
            onReady: function() { resolve(player); },
            onStateChange: function(event) {
              if (event.data === YT.PlayerState.PLAYING) self.setAttribute('playing', '');
              else if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) self.removeAttribute('playing');
            }
          }
        });
      });
    }
    setupVimeoPlayer() {
      var self = this;
      return new Promise(async function(resolve) {
        if (!window.Vimeo || !window.Vimeo.Player) await loadScript('https://player.vimeo.com/api/player.js');
        var player = new Vimeo.Player(self.querySelector('iframe'));
        player.on('play', function() { self.setAttribute('playing', ''); });
        player.on('pause', function() { self.removeAttribute('playing'); });
        player.on('ended', function() { self.removeAttribute('playing'); });
        resolve(player);
      });
    }
    get host() { return this.getAttribute('host'); }
  }

  if (!customElements.get('video-media')) {
    customElements.define('video-media', VideoMedia);
  }
})();
